import {
  ChangeSimEsimDataVerificationPage,
  NavigationWithUserContext,
  RequiredDashboardData,
} from "@nju/feature-portal-dashboard";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";

export default function ChangeSimCardIdentityConfirm() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl" tone="gray">
        <RequiredDashboardData extendedMode="mobile">
          <NavigationWithUserContext />
          <ChangeSimEsimDataVerificationPage selectedSimCardType="SIM" />
        </RequiredDashboardData>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
